export const Spacing = (s: number) => `${s * 4}px`;
